import React, { ReactNode, useEffect, useState } from 'react'
import styled from 'styled-components'

import Popper from 'components/Popper'

type Props = {
  display: boolean
  children: ReactNode
}

const FollowMouse = ({ display, children }: Props) => {
  const [top, setTop] = useState(0)
  const [left, setLeft] = useState(0)

  useEffect(() => {
    const handleMousePostion = (e: MouseEvent) => {
      setTop(e.clientY)
      setLeft(e.clientX)
    }

    document.addEventListener('mousemove', handleMousePostion)

    return () => {
      document.removeEventListener('mousemove', handleMousePostion)
    }
  }, [])

  return (
    <S.Popper
      anchorEl={{
        getBoundingClientRect: () => ({ width: 0, height: 0, top, right: left, bottom: top, left, x: left, y: top, toJSON: () => {} })
      }}
      open={display && top !== 0 && left !== 0}
    >
      {children}
    </S.Popper>
  )
}

export default FollowMouse

const S = {
  Popper: styled(Popper)`
    pointer-events: none;
    z-index: 1400
  `
}
